import React from 'react'
import { Label } from 'atoms/Texts'
import { ButtonReg } from 'atoms/Buttons'
import IconPng from 'components/atoms/IconPng/index';
import { BtnRow, BtnAzureRow, BtnClassicLoginRow, HorizontalLine } from './styles'
import { withRouter } from 'react-router-dom'
import { withTheme } from 'styled-components'

const ic_azure = require('App/assets/images/ic_azure_white.svg')

const LoginButtonGrouped = (props) => {
  const {
    fnOnLoginWithAzure,
    fnSwitch,
    theme,
    isClassicLoginEnable
  } = props

  return (
    <div>
      <BtnRow>
        <ButtonReg
          btnTxt={
            <BtnAzureRow>
              <IconPng srcIcon={ic_azure} mr={'8px'} size={'auto'} h={'14'} showPointer={true} />
              Login with Azure
            </BtnAzureRow>
          }
          onClick={fnOnLoginWithAzure}
          width={'100%'}
          height={'34px'}
          margin={'0px 0px 12px'}
        />
        {isClassicLoginEnable && (
          <BtnClassicLoginRow
            onClick={fnSwitch}
          >
            <HorizontalLine color={theme.mocaGreen} mr={'6px'} />
            <Label
              size={'14px'}
              weight={'500'}
              mb={'0px'}
              color={theme.mocaGreen}
              showPointer
            >
              Click Here for Classic Login
            </Label>
            <HorizontalLine color={theme.mocaGreen} ml={'6px'} />
          </BtnClassicLoginRow>
        )}
      </BtnRow>
    </div>
  )
}

export default withRouter(
  withTheme(LoginButtonGrouped)
)
